import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent } from '@/components/ui/card';
import { Construction } from 'lucide-react';

/**
 * Estado vacío de las secciones que todavía no tienen backend.
 * Muestra qué va a hacer la sección y en qué parte del módulo entra, en vez de
 * dejar un 404 o una pantalla en blanco que parezca un error.
 */
const SeccionPendiente = ({ icon: Icon, titulo, descripcion, entrega }) => (
  <motion.div
    initial={{ opacity: 0, y: 10 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.3 }}
  >
    <Card className="h-full">
      <CardContent className="flex flex-col items-center justify-center text-center py-16 px-6">
        <div className="p-3 rounded-full bg-primary/15 mb-4">
          <Icon className="h-7 w-7 text-primary" />
        </div>
        <h2 className="text-lg font-semibold text-gray-800">{titulo}</h2>
        <p className="text-sm text-gray-500 mt-2 max-w-md">{descripcion}</p>
        <span className="mt-4 inline-flex items-center gap-1.5 text-xs text-gray-400 bg-gray-50 px-3 py-1.5 rounded-full">
          <Construction className="h-3.5 w-3.5" />
          {entrega}
        </span>
      </CardContent>
    </Card>
  </motion.div>
);

export default SeccionPendiente;